import { useCallback, useState } from 'react';

//------------------------------------------------------------------------------
export const useContextMenu = () => {
  const [contextMenu, setContextMenu] = useState<{
    isOpen: boolean;
    position: { x: number; y: number };
    nodeId: number | undefined;
    nodeType: 'person' | 'relationship';
  }>({
    isOpen: false,
    position: { x: 0, y: 0 },
    nodeId: undefined,
    nodeType: 'person',
  });

  //----------------------------------------------------------------------------
  const openContextMenu = useCallback(
    (
      nodeId: number,
      position: { x: number; y: number },
      nodeType: 'person' | 'relationship'
    ) => {
      setContextMenu({
        isOpen: true,
        position,
        nodeId,
        nodeType,
      });
    },
    []
  );

  //----------------------------------------------------------------------------
  const closeContextMenu = useCallback(() => {
    setContextMenu((prev) => ({ ...prev, isOpen: false }));
  }, []);

  //----------------------------------------------------------------------------
  return {
    contextMenu,
    openContextMenu,
    closeContextMenu,
  };
};
